// extracted by mini-css-extract-plugin
export default {"btn_zamknij":"DodajBrakBtn_btn_zamknij__Bf6EO"};